import { useArrayDropdown } from "./useArrayDropdown";

export const useEnumDropdown = <T extends Record<string, string | number>>(
  enumObj: T,
  translationKeyPrefix: string,
  allowEmptyValue: boolean
) => {
  return useArrayDropdown(Object.values(enumObj), translationKeyPrefix, allowEmptyValue);
};
